app.component('animatedEllipsis', {
    template: `<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>`
});